import config from '@config';
import merge from 'lodash/merge';

const fontFamily = 'FedraSansStd-medium';

const commonLangStyle = ({ lang, ...props }) => {
  const isIndian = config.indianLang.indexOf(lang) > -1;
  const styleObj = {
    heading: {
      fontSize: { lg: '160px', md: '100px', base: '62px' },
      fontFamily: isIndian ? config.momLangFont[lang] : 'Trirong',
      lineHeight: { base: '1.1em', md: '80px', lg: '135px' },
    },
    titleSubtext: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontSize: { md: '48px', base: '28px' },
      lineHeight: { base: '1.1em', md: '52px' },
      color: '#fff',
      fontWeight: 500,
    },
    closedMessage: {
      fontSize: { lg: '64px', md: '60px', base: '42px' },
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      lineHeight: { lg: '1.1em', md: '66px', base: '46px' },
    },
    bottomText: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontSize: '20px',
      lineHeight: { base: '1.1em', md: '22px' },
      color: 'rgba(255, 255, 255, 0.60)',
    },
    quoteSt: {
      fontSize: { base: '24px', sm: '24px', md: '32px', lg: '32px' },
      fontFamily: isIndian ? config.momLangFont[lang] : 'Trirong',
      fontWeight: '400',
      lineHeight: {
        base: '34px',
        md: '44px',
        lg: '1.1em',
      },
    },
    buttonStI: {
      fontWeight: '400',
      fontSize: { base: '22px', md: '1.5rem' },
      lineHeight: { base: '22.2px', md: '30.8px' },
      fontFamily: isIndian ? config.momLangFont[lang] : 'Trirong',
      color: '#EC1C2D',
    },
    buttonSt: {
      fontSize: { base: '22px', md: '1.5rem' },
      lineHeight: { base: '22.2px', md: '30.8px' },
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      color: '#EC1C2D',
    },
    stickyButtonSt: {
      fontSize: '18px',
      lineHeight: '1.5rem',
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
    },
  };

  const finalObj = merge(styleObj, { ...props });
  return finalObj;
};

const TopBannerSt = {
  en: commonLangStyle({ lang: 'en' }),
  bn: commonLangStyle({ lang: 'bn' }),
  hi: commonLangStyle({
    lang: 'hi',
  }),
  te: commonLangStyle({ 
    lang: 'te',
    closedMessage: {
      fontSize: { lg: '48px', md: '28px', base: '28px' },
      fontFamily: config.momLangFont['ta'],
      lineHeight: { lg: '2em', md: '66px', base: '50px' },
    },
    quoteSt: {
      lineHeight: { base: '34px', md: '44px', lg: '1.4em' },
    }, 
  }),
  kn: commonLangStyle({ lang: 'kn' }),
  gu: commonLangStyle({ lang: 'gu' }),
  mr: commonLangStyle({ lang: 'mr' }),
  ml: commonLangStyle({ lang: 'ml' }),
  'zh-tw': commonLangStyle({ lang: 'zh-tw' }),
  zh: commonLangStyle({ lang: 'zh' }),
  it: commonLangStyle({ lang: 'it' }),
  fr: commonLangStyle({ lang: 'fr' }),
  de: commonLangStyle({ lang: 'de' }),
  es: commonLangStyle({ lang: 'es' }),
  ru: commonLangStyle({ lang: 'ru' }),
  ta: commonLangStyle({
    lang: 'ta',
    closedMessage: {
      fontSize: { lg: '48px', md: '28px', base: '28px' },
      fontFamily: config.momLangFont['ta'],
      lineHeight: { lg: '88px', md: '30px', base: '30px' },
    },
    heading: {
      fontSize: { lg: '120px', md: '100px', base: '62px' },
      fontFamily: config.momLangFont['ta'],
      lineHeight: { base: '120px', md: '135px' },
    },
    titleSubtext: {
      fontFamily: config.momLangFont['ta'],
      fontSize: { md: '48px', base: '28px' },
      lineHeight: { base: '1.2em', md: '52px' },
      color: '#fff',
      fontWeight: 500,
    },
    buttonSt: {
      fontSize: { base: '18px', md: '20px' },
      lineHeight: { base: '22.2px', md: '30.8px' },
      fontFamily: config.momLangFont['ta'],
      color: '#EC1C2D',
    },
    bottomText: {
      fontFamily: config.momLangFont['ta'],
      fontSize: { md: '20px', base: '18px' },
      lineHeight: { base: '20px', md: '22px' },
      color: 'rgba(255, 255, 255, 0.60)',
    },
  }),
  cn: commonLangStyle({ lang: 'cn' }),
  ar: commonLangStyle({
    lang: 'ar',
  }),
  id: commonLangStyle({ lang: 'id' }),
};
export default TopBannerSt;
